export default "__VITE_ASSET__ab3e7008__"